<template>
    <div class="shopDetails">
        <div>
            <el-row>
                <el-col :span="18">
                    <div class="goods-info">
                        <div class="media" v-if="commodityDetails.itemPicture">
                            <GoodsImage :images="swiperList"></GoodsImage>
                        </div>
                        <div class="spec">
                            <div class="goods-sku">
                                <p class="clap">
                                    {{!commodityDetails.msg||commodityDetails.msg==' '?commodityDetails.title:commodityDetails.title+'·'+commodityDetails.msg}}
                                </p>
                                <div class="rechargeItem">
                                    <div class="iponer" v-if="commodityDetails.biddingMode=='明拍'">
                                        <p class="g-price">
                                            <span class="g-rena">当前最高价</span>
                                            <span class="fz18 red fwB">¥</span>
                                            <span class="fz30 red fwB">
                                                {{commodityDetailsLong.maxPrice==0?commodityDetails.reservePrice:commodityDetailsLong.maxPrice}}
                                            </span>
                                            <span class="g-resa">
                                                /
                                                {{commodityDetails.unitedTitle==null?'吨':commodityDetails.unitedTitle}}
                                            </span>
                                        </p>
                                        <p class="posasa">
                                            <i class="el-icon-magic-stick" style="color:#FFB71C;"></i>
                                            <span class="riesa">明标</span>
                                        </p>
                                        <p class="g-price" style="margin-top: 20px;">
                                            <span class="g-rena">抢购底价</span>
                                            <span class=" blue fz18">
                                                ¥{{commodityDetails.biddingMode=='明拍'?commodityDetails.reservePrice:commodityDetails.status==2?commodityDetails.reservePrice:"???"}}
                                            </span>
                                            <span class="g-resa">
                                                /
                                                {{commodityDetails.unitedTitle==null?'吨':commodityDetails.unitedTitle}}
                                            </span>
                                        </p>
                                    </div>
                                    <div class="iponer" v-else>
                                        <p class="g-price">
                                            <span class="g-rena">当前最高价</span>
                                            <span class="fz18 red fwB">¥</span>
                                            <span class="fz30 red fwB">
                                                <span v-if="commodityDetails.status<2">???</span>
                                                <span
                                                    v-if="commodityDetails.status==2&&commodityDetails.isPublic!='2'">{{commodityDetailsLong.maxPrice==0?commodityDetails.reservePrice:commodityDetailsLong.maxPrice}}</span>
                                                <span
                                                    v-if="commodityDetails.status==2&&commodityDetails.isPublic=='2'">???</span>
                                            </span>
                                            <span class="g-resa">
                                                /
                                                {{commodityDetails.unitedTitle==null?'吨':commodityDetails.unitedTitle}}
                                            </span>
                                        </p>
                                        <p class="posasa">
                                            <i class="el-icon-magic-stick" style="color:#FFB71C;"></i>
                                            <span class="riesa">暗标</span>
                                        </p>
                                        <p class="g-price" style="margin-top: 20px;">
                                            <span class="g-rena">抢购底价</span>
                                            <span class=" blue fz18">
                                                ¥{{commodityDetails.biddingMode=='明拍'?commodityDetails.reservePrice:commodityDetails.status==2?commodityDetails.reservePrice:"???"}}
                                            </span>
                                            <span class="g-resa">
                                                /
                                                {{commodityDetails.unitedTitle==null?'吨':commodityDetails.unitedTitle}}
                                            </span>
                                        </p>
                                    </div>
                                    <div class="iperssaa">
                                        <span v-if="startCountDown<=0&&endCountDown>0">距离结束还有</span>
                                        <span class="miaosha" v-if="startCountDown<=0&&endCountDown>0">
                                            {{endCountDown|commodityDetailsTime2}}
                                        </span>

                                        <span class="iperssaa_over"
                                            v-if="startCountDown<=0&&endCountDown<=0">活动已结束</span>

                                        <span v-if="startCountDown>0">距开始</span>
                                        <span class="miaosha" v-if="startCountDown>0">
                                            {{startCountDown|commodityDetailsTime2}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div class="container">
                                    <span class="item">
                                        <i class="i-colea">竞拍总量</i>
                                        <i
                                            class="i-coleasss">{{commodityDetails.biddingAmount}}{{commodityDetails.numUnit}}</i>
                                    </span>
                                    <span class="item">
                                        <i class="i-colea">申买量</i>
                                        <i
                                            class="i-coleasss">{{commodityDetailsLong.amount|zero}}{{commodityDetails.numUnit}}</i>
                                    </span>
                                    <span class="item">
                                        <i class="i-colea">最低竞拍量</i>
                                        <i
                                            class="i-coleasss">{{commodityDetails.startingVolume}}{{commodityDetails.numUnit}}</i>
                                    </span>
                                    <span class="item">
                                        <i class="i-colea">浏览量</i>
                                        <i class="i-coleasss">{{commodityDetails.lookTimes}}</i>
                                    </span>
                                    <span class="item">
                                        <i class="i-colea">交易量</i>
                                        <i
                                            class="i-coleasss">{{commodityDetails.purchaseAmount|zero}}{{commodityDetails.numUnit}}</i>
                                    </span>
                                </div>
                            </div>
                            <div>
                                <button class="xtx-button xtx-button2 ellipsis" v-show="startCountDown>0">
                                    未开始，请耐心等待
                                </button>
                                <button class="xtx-button ellipsis"
                                    v-if="startCountDown<=0&&endCountDown>0&&(commodityDetails.myRecordlist==''||commodityDetails.myRecordlist==null)"
                                    @click="offerAPriceFn">
                                    立即参与
                                </button>
                                <button class="xtx-button ellipsis"
                                    v-if="startCountDown<=0&&endCountDown>0&&commodityDetails.myRecordlist!=''&&commodityDetails.myRecordlist!=null"
                                    @click="offerAPriceFn">
                                    继续参与
                                </button>
                                <button class="xtx-button ellipsis" v-if="endCountDown<=0&&orderStatus"
                                    @click="examineOrder">
                                    查看订单
                                </button>
                                <button v-if="endCountDown<=0&&commodityDetails.myRecordlist==''"
                                    class="xtx-button xtx-button2 ellipsis">
                                    已结束
                                </button>
                                <button v-if="endCountDown<=0&&commodityDetails.myRecordlist!=''&&!orderStatus"
                                    class="xtx-button xtx-button2 ellipsis">
                                    抢购失败
                                </button>
                            </div>
                            <!-- <div>
                                <i class="el-icon-apple"></i>
                                <span class="shoucan">收藏产品</span>
                                <span class="shoucan">点击查看规则</span>
                            </div> -->
                        </div>
                    </div>
                </el-col>
                <el-col :span="6">
                    <ShopCompany></ShopCompany>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="18">
                    <div style=" margin-right: 60px;">
                        <div class="productDetail">
                            <div class="detailTabs">
                                <span :class="{compActive: currentComp === 'detailData' }"
                                    v-if="commodityDetails.biddingMode=='明拍'"
                                    @click="clickSwitchTab(type = 'detailData')">当前出价</span>
                                <span :class="{compActive: currentComp === 'evaluation'}"
                                    @click="clickSwitchTab(type = 'evaluation')">产品详情</span>
                                <span :class="{compActive: currentComp === 'finalize'}"
                                    v-if="commodityDetails.companyId!=$store.state.userId"
                                    @click="clickSwitchTab(type = 'finalize')">我的出价</span>
                            </div>
                            <div class="detailBox clearfix">
                                <!-- 竞拍买家 -->
                                <div v-show="currentComp=='buyUser'">
                                    <div style="margin-top: 14px;" v-for="(item,index) in commodityDetails.allOrderList"
                                        :key="index">
                                        <el-row>
                                            <el-col :span="24">
                                                <div class="mokis">
                                                    <div>
                                                        <i class="el-icon-s-open origin"></i>
                                                        <span class="fz14 fwB origin">商议订单中</span>
                                                    </div>
                                                    <div>
                                                        <span class="fz14" style="margin-right: ;">
                                                            {{item.createDate|commodityDetailsTime3}}
                                                        </span>
                                                        <span class="fz14">
                                                            <span
                                                                class="fz16 fwB origin">¥{{item.bidPrice}}</span>/{{commodityDetails.unitedTitle==null?'吨':commodityDetails.unitedTitle}}
                                                        </span>
                                                    </div>
                                                </div>
                                            </el-col>
                                            <el-col :span="24">
                                                <div class="mokisas">
                                                    <span>{{item.companyName}}
                                                        {{item.createDate|commodityDetailsTime3}}</span>
                                                    <span class="blue" @click="examineOrder2(item)"><i
                                                            class="el-icon-s-order"></i> 查看详情</span>
                                                </div>
                                            </el-col>
                                            <el-col :span="24">
                                                <el-row class="dassaf">
                                                    <el-col :span="11" class="mokiiua">
                                                        <span>意向价格
                                                            ¥{{item.bidPrice}}/{{commodityDetails.unitedTitle==null?'吨':commodityDetails.unitedTitle}}</span>
                                                        <span>意向量
                                                            {{item.totalAmount}}/{{commodityDetails.numUnit}}</span>
                                                    </el-col>
                                                    <el-col :span="13" class="mokiiua blue">
                                                    </el-col>
                                                </el-row>
                                            </el-col>
                                        </el-row>
                                    </div>
                                </div>
                                <!-- 我的出价 -->
                                <div class="detailInfoBox">
                                    <div v-show="currentComp==='finalize'">
                                        <div class="detailBox">
                                            <el-table :cell-style="{'text-align':'center'}"
                                                :header-cell-style="{background:'#F5F5F6 ',color:'#000000','text-align':'center'}"
                                                :data="commodityDetails.myRecordlist" style="width: 100%">
                                                <el-table-column prop="bidPrice"
                                                    :label="'出价（元/'+(commodityDetails.unitedTitle==null?'吨':commodityDetails.unitedTitle)+'）'">
                                                    <template slot-scope="props">
                                                        <span class="red">{{props.row.bidPrice}}</span>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column prop="bidAmount"
                                                    :label="'申买量（'+(commodityDetails.unitedTitle==null?'吨':commodityDetails.unitedTitle)+'）'">
                                                </el-table-column>
                                                <el-table-column prop="bidDate" label="日期">
                                                    <template slot-scope="props">
                                                        <span>{{props.row.bidDate|commodityDetailsTime3}}</span>
                                                    </template>
                                                </el-table-column>
                                            </el-table>
                                        </div>
                                    </div>
                                    <!-- 当前出价 -->
                                    <div v-show="currentComp=='detailData'">
                                        <div class="detailBox">
                                            <el-table :cell-style="{'text-align':'center'}"
                                                :header-cell-style="{background:'#F5F5F6 ',color:'#000000','text-align':'center'}"
                                                :data="commodityDetailsLong.allRecordlist" style="width: 100%">
                                                <el-table-column prop="bidPrice"
                                                    :label="'出价（元/'+(commodityDetails.unitedTitle==null?'吨':commodityDetails.unitedTitle)+'）'">
                                                    <template slot-scope="props">
                                                        <span class="red">{{props.row.bidPrice}}</span>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column prop="bidAmount"
                                                    :label="'申买量（'+(commodityDetails.unitedTitle==null?'吨':commodityDetails.unitedTitle)+'）'">
                                                </el-table-column>
                                                <el-table-column prop="bidDate" label="日期">
                                                    <template slot-scope="props">
                                                        <span>{{props.row.bidDate|commodityDetailsTime3}}</span>
                                                    </template>
                                                </el-table-column>
                                            </el-table>
                                        </div>
                                    </div>
                                    <div v-show="currentComp=='evaluation'">
                                        <!-- 产品详情 -->
                                        <div>
                                            <div class="evaluation-box">
                                                <div>
                                                    <div>交货方式</div>
                                                    <div>{{commodityDetails.deliveryMethod}}</div>
                                                </div>
                                                <div>
                                                    <div>货源地</div>
                                                    <div>{{commodityDetails.location}}</div>
                                                </div>
                                                <div>
                                                    <div>付款方式</div>
                                                    <div>{{commodityDetails.paymentMethod}}</div>
                                                </div>
                                                <div>
                                                    <div>货物品质</div>
                                                    <div>
                                                        <span
                                                            v-show="productNameJC(commodityDetails.title)">{{commodityDetails.description}}</span>
                                                        <span v-show="!productNameJC(commodityDetails.title)">
                                                            {{commodityDetails.domestic}}
                                                            {{commodityDetails.qualityOfGoods}}
                                                            {{commodityDetails.qualityOfGoodsOne}}
                                                            {{commodityDetails.itemCharacteristics==null||commodityDetails.itemCharacteristics==""?" ":"乙醇含量低于"+commodityDetails.itemCharacteristics+"单位PPM "}}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div>
                                                    <div>起拍量</div>
                                                    <div>{{commodityDetails.startingVolume}}{{commodityDetails.numUnit}}
                                                    </div>
                                                </div>
                                                <div>
                                                    <div>竞拍量</div>
                                                    <div>{{commodityDetails.biddingAmount}}{{commodityDetails.numUnit}}
                                                    </div>
                                                </div>
                                                <div>
                                                    <div>提货周期</div>
                                                    <div>{{commodityDetails.deliveryCycle}}天</div>
                                                </div>
                                                <div>
                                                    <div>加价幅度</div>
                                                    <div>每次{{commodityDetails.fareIncrease}}元</div>
                                                </div>
                                                <div>
                                                    <div>竞拍时间</div>
                                                    <div>
                                                        {{commodityDetails.biddingStartdate|commodityDetailsTime}}至{{commodityDetails.biddingEnddate|commodityDetailsTime}}
                                                    </div>
                                                </div>
                                                <div>
                                                    <div>商品描述</div>
                                                    <div>{{commodityDetails.details}}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-col>

                <!-- <el-col :span="6">
                    <span>推荐产品</span>
                    <commodityDetails></commodityDetails>
                </el-col> -->
            </el-row>
        </div>
        <div class="mark" v-show="isOfferAPrice"></div>
        <div class="mark mark2" v-show="confirmShow"></div>
        <div class="pup" v-show="isOfferAPrice">
            <div @click="cancelOfferAPriceFn"><i class="el-icon-close"></i></div>
            <div>{{commodityDetails.title}}</div>
            <div>
                <div>
                    竞拍价元/元{{commodityDetails.unitedTitle==null?'吨':commodityDetails.unitedTitle}}
                </div>
                <div>
                    <div @click="offerAPriceChangeFn('sub')">
                        <span>-</span>
                    </div>
                    <div>
                        <input type="" name="" id="" value="" readonly="readonly" v-model="offerAPrice" />
                    </div>
                    <div @click="offerAPriceChangeFn('add')">
                        <span>+</span>
                    </div>
                </div>
            </div>
            <div>
                <div>
                    <div>竞拍总量</div>
                </div>
                <div>
                    <div>{{commodityDetails.biddingAmount}}{{commodityDetails.numUnit}}</div>
                    <div>起拍量</div>
                    <div>{{commodityDetails.startingVolume}}{{commodityDetails.numUnit}}</div>
                </div>
            </div>
            <div>
                <div>购买数量/{{commodityDetails.numUnit}}</div>
                <div>
                    <div @click="quantityChangeFn('sub')">
                        <span>-</span>
                    </div>
                    <div>
                        <input v-model="quantity" @keyup="quantityChange"
                            onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}" />
                    </div>
                    <div @click="quantityChangeFn('add')">
                        <span>+</span>
                    </div>
                </div>
            </div>
            <div>
                <div>提货地点</div>
                <div class="origin">{{commodityDetails.location}}</div>
            </div>
            <div>
                <div>总计</div>
                <div class="origin">¥{{aggregate}}</div>
            </div>
            <div @click="estimate">确定</div>
        </div>
        <div class="pup2" v-if="confirmShow">
            <div @click="confirmShow=false"><i class="el-icon-close"></i></div>
            <div>
                <div>
                    <div>竞拍价</div>
                    <div>{{offerAPrice}}</div>
                </div>
                <div>
                    <div>竞拍量</div>
                    <div>¥{{quantity}}</div>
                </div>
                <div>
                    <div>总计</div>
                    <div class="red">¥{{offerAPrice*quantity}}</div>
                </div>
            </div>
            <div>
                <div @click="confirmOfferAPriceFn">确认抢购</div>
                <div @click="cancelOfferAPriceFn">取消抢购</div>
            </div>
        </div>
    </div>

</template>
<script>
    import commodityDetails from '../commodity'
    import GoodsImage from "../goods-image.vue"
    import intesaTask from "../goods-sku.vue";

    import ShopCompany from "../../components/ShopCompany.vue"
    export default {
        data() {
            return {
                swiperList: [],
                currentComp: 'evaluation', //显示的内容，默认显示详情

                commodityId: '', //商品Id
                commodityDetails: {
                    myRecordlist: []
                }, //商品详情
                commodityDetailsLong: {
                    allRecordlist: []
                }, //商品详情长链接
                startCountDown: 0, //开始倒计时
                endCountDown: 0, //结束倒计时
                startTimer: null, //开始倒计时定时器
                endTimer: null, //结束倒计时定时器
                orderStatus: false, //是否抢购成功
                timer: true, //倒计时否已启动
                isOfferAPrice: false, //出价模块是否显示
                isConfirmOfferAPrice: false, //确定出价模块是否显示
                offerAPriceStatus: false, //参与出价的资格
                moneyLack: false, //保证金不足
                offerAPrice: 0, //出价
                quantity: 0, //数量
                aggregate: 0, //总价
                loading: false,

                recordList: [],

                confirmShow: false
            };
        },
        components: {
            commodityDetails,
            GoodsImage,
            // HeaderBar,
            intesaTask,
            ShopCompany
        },
        mounted() {
            var that = this;
            clearInterval(this.startTimer);
            clearInterval(this.endTimer);
            that.startTimer = null;
            that.endTimer = null;
            that.commodityId = that.$route.query.commodityId;
            that.getCommodityDetailsLong();
            that.getRecordList();
        },
        methods: {
            quantityChange: function(e) {
                let that = this;
                let dom = e.currentTarget;
                if (dom.value.length == 1) {
                    dom.value = dom.value.replace(/[^1-9]/g, '')
                } else {
                    dom.value = dom.value.replace(/\D/g, '')
                }
                that.quantity = dom.value;
                that.aggregate = that.mul(that.offerAPrice, that.quantity);
            },
            //确认出价
            confirmOfferAPriceFn: function() {
                var that = this;
                this.request.get(this.$store.state.httpUrl + "userDetails/findUserPerson", {
                    params: {
                        id: that.$store.state.userId,
						flag: that.$store.state.isPerson
                    }
                }).then(res => {
                    if (res.status == 200) {
                        if (res.data.isNotCertified != '2') {
                            that.$confirm('您好，您还没有认证，暂时不能操作，是否去认证?', '认证提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(() => {
                                that.$router.push({
                                    path: '/authentication',
                                    query: {

                                    }
                                });
                            }).catch(() => {});
                        } else {
                            nextStep();
                        }
                    }
                });

                function nextStep() {
                    that.request.get(that.$store.state.frameworkUrl + 'order/participateAuction', {
                        params: {
                            biddingDealsId: that.commodityId,
                            companyId: that.$store.state.userId,
                            companyName: that.$store.state.userName,
                            bidPrice: that.offerAPrice,
                            bidAmount: that.quantity
                        }
                    }).then(function(res) {
                        let data = res;
                        if (data.isSuccess) {
                            if (data.responseCode == '200') {
                                setTimeout(function() {
                                    takeOrderPolling(data.data)
                                }, 150);
                            } else {
                                that.isConfirmOfferAPrice = false;
                                that.$message({
                                    message: data.msg,
                                    type: 'warning'
                                });
                            }
                        } else {
                            that.isConfirmOfferAPrice = false;
                            that.$message({
                                message: data.responseMsg,
                                type: 'warning'
                            });
                        }
                    }, function(res) {
                        that.isConfirmOfferAPrice = false;
                    })

                    function takeOrderPolling(id) {
                        that.request.get(that.$store.state.frameworkUrl + 'order/auctionOrderPolling', {
                            params: {
                                orderId: id
                            }
                        }).then(function(res) {
                            let data = res;
                            if (data.isSuccess) {
                                if (data.responseCode == '200') {
                                    that.isOfferAPrice = false;
                                    that.confirmShow = false;
                                    that.isConfirmOfferAPrice = false;
                                    that.getCommodityDetails();
                                    // that.$router.push({
                                    //     path: '/order_jp',
                                    //     query: {
                                    //         orderId: id
                                    //     }
                                    // });
                                } else if (data.responseCode == '5') {
                                    that.moneyLack = true;
                                } else {
                                    if (data.refreshTime == 0) {
                                        that.$message({
                                            type: data.responseMsg,
                                            type: 'warning'
                                        });
                                        that.isConfirmOfferAPrice = false;
                                    } else {
                                        setTimeout(function() {
                                            takeOrderPolling(id)
                                        }, data.refreshTime);
                                    }
                                }
                            } else {
                                that.$message({
                                    type: data.responseMsg,
                                    type: 'warning'
                                });
                                that.isConfirmOfferAPrice = false;
                            }
                        }, function(res) {
                            that.isConfirmOfferAPrice = false;
                        })
                    }
                }
            },
            //判断填写的价格和数量是否符合规则
            estimate: function() {
                var that = this;
                if (that.commodityDetails.myRecordlist != '' && that.commodityDetails.myRecordlist != null) {
                    // if(that.offerAPrice <= that.commodityDetails.myRecordlist[0].bidPrice) {
                    // 	MessageBox.alert('本次出价不能少于上次出价', '提示');
                    // 	return false;
                    // }

                    if (that.offerAPrice < that.commodityDetails.myRecordlist[0].bidPrice) {
                        this.$message({
                            message: '本次出价不能少于上次出价',
                            type: 'warning'
                        });
                        return
                    }

                    if (that.offerAPrice == that.commodityDetails.myRecordlist[0].bidPrice) {
                        if (that.quantity <= that.commodityDetails.myRecordlist[0].bidAmount) {
                            this.$message({
                                message: '购买数量必须高于上次购买数量',
                                type: 'warning'
                            });
                            return false;
                        }
                    }
                } else {
                    if (that.offerAPrice < that.commodityDetails.reservePrice) {
                        this.$message({
                            message: '本次出价不能低于起购价',
                            type: 'warning'
                        });
                        return false;
                    }
                }
                if (that.commodityDetails.title == '甲醇') {
                    if (that.quantity % 10 != 0) {
                        this.$message({
                            message: '购买的数量必须为10的倍数',
                            type: 'warning'
                        });
                        return false;
                    }
                }
                if (that.quantity < that.commodityDetails.startingVolume) {
                    this.$message({
                        message: '购买数量不能少于起拍量',
                        type: 'warning'
                    });
                    return false;
                }
                if (that.quantity > that.commodityDetails.biddingAmount) {
                    this.$message({
                        message: '购买数量不能大于总量',
                        type: 'warning'
                    });
                    return false;
                }
                that.isConfirmOfferAPrice = !that.isConfirmOfferAPrice;
                that.confirmShow = !that.confirmShow;
                // this.confirmOfferAPriceFn();
            },
            //取消出价
            cancelOfferAPriceFn: function() {
                this.isOfferAPrice = false;
                this.isConfirmOfferAPrice = false;
                this.confirmShow = false;
            },
            //参与出价
            offerAPriceFn: function() {
                let that = this
                if (sessionStorage.getItem('permission') == '2') {
                    that.$message.error('您不是交易员，没有该权限');
                    return false;
                }
                if (that.offerAPriceStatus) {
                    that.isOfferAPrice = !that.isOfferAPrice;
                } else {
                    this.$message({
                        message: '您无法参与本次交易，如有需要，请联系客服电话0316-2597680',
                        type: 'warning'
                    });
                }
            },
            //改变数量
            quantityChangeFn: function(str) {
                var that = this;
                if (str == 'add') {
                    if (that.commodityDetails.title == '甲醇') {
                        that.quantity = that.add(that.quantity, 10);
                    } else {
                        that.quantity = that.add(that.quantity, 1);
                    }
                }
                if (str == 'sub') {
                    if (that.commodityDetails.title == '甲醇') {
                        that.quantity = that.sub(that.quantity, 10);
                    } else {
                        that.quantity = that.sub(that.quantity, 1);
                    }
                    if (that.quantity <= that.commodityDetails.startingVolume) {
                        that.quantity = that.commodityDetails.startingVolume;
                    }
                }
                that.aggregate = that.mul(that.offerAPrice, that.quantity);
            },
            //改变出价
            offerAPriceChangeFn: function(str) {
                var that = this;
                if (str == 'add') {
                    that.offerAPrice = that.add(that.offerAPrice, that.commodityDetails.fareIncrease);
                }
                if (str == 'sub') {
                    that.offerAPrice = that.sub(that.offerAPrice, that.commodityDetails.fareIncrease);
                }
                that.aggregate = that.mul(that.offerAPrice, that.quantity);
            },
            examineOrder2(item) {
                this.$router.push({
                    path: '/order_jp',
                    query: {
                        orderId: item.biddingOrdersId,
                        dealType: 'B',
                        userId: item.companyId,
                    }
                });
            },
            examineOrder() {
                this.getCommodityDetails('order');
            },
            getCommodityDetails: function(str) {
                let that = this;
                this.request.get(this.$store.state.httpUrl + "mobileInterf/queryOne", {
                    params: {
                        id: that.commodityId,
                        commodityType: 'B',
                        userId: that.$store.state.userId
                    }
                }).then(res => {
                    if (res.status == 200) {
                        if (str == 'order') {
                            that.$router.push({
                                path: '/order_jp',
                                query: {
                                    orderId: res.data.orderId,
                                    dealType: 'B',
                                    userId: that.$store.state.userId
                                }
                            });
                            return false;
                        }
                        //获取商品详情
                        that.commodityDetails = res.data;
                        //获取开始倒计时
                        that.startCountDown = that.commodityDetails.startTimeCountingDown;
                        //获取出价填充值
                        that.offerAPrice = that.commodityDetails.myRecordlist != '' && that.commodityDetails
                            .myRecordlist != null ? that.commodityDetails.myRecordlist[0].bidPrice : that
                            .commodityDetails.reservePrice;
                        //获取数量填充值
                        that.quantity = that.commodityDetails.startingVolume;
                        //获取总价填充值
                        that.aggregate = that.mul(that.offerAPrice, that.quantity);
                        //判断参与的资格
                        if (that.commodityDetails.isParticipants == '1') {
                            for (var i = 0; i < that.commodityDetails.userIds.length; i++) {
                                if (that.$store.state.userId == that.commodityDetails.userIds[i].userId) {
                                    that.offerAPriceStatus = true;
                                    break;
                                } else {
                                    if (i == that.commodityDetails.userIds.length - 1) {
                                        that.offerAPriceStatus = false;
                                    }
                                }
                            }
                        } else if (that.commodityDetails.isParticipants == '2') {
                            for (var i = 0; i < that.commodityDetails.userIds.length; i++) {
                                if (that.$store.state.userId == that.commodityDetails.userIds[i].userId) {
                                    that.offerAPriceStatus = false;
                                    break;
                                } else {
                                    if (i == that.commodityDetails.userIds.length - 1) {
                                        that.offerAPriceStatus = true;
                                    }
                                }
                            }
                        } else {
                            that.offerAPriceStatus = true;
                        }
                        //是否抢购成功
                        if (that.commodityDetails.orderStatus) {
                            that.orderStatus = true;
                        } else {
                            that.orderStatus = false;
                        }
                        //判断定时器是否已启动，如果没有，则启动开始倒计时定时器
                        if (that.timer) {
                            that.startCountDownMode();
                        }
                        that.swiperList = [];
                        that.swiperList.push(res.data.itemPicture);
                    }
                });
            },
            //结束倒计时定时任务
            endCountDownMode: function() {
                let that = this;
                if (that.startCountDown <= 0) {
                    if (that.endCountDown > 0) {
                        that.endTimer = setInterval(function() {
                            that.endCountDown -= 1000;
                            that.getCommodityDetailsLong();
                            if (that.endCountDown <= 0) {
                                that.$forceUpdate();
                                clearInterval(that.endTimer);
                            }
                        }, 1000)
                    }
                }
            },
            //开始倒计时定时任务
            startCountDownMode: function() {
                let that = this;
                that.timer = false;
                if (that.startCountDown <= 0) {
                    that.getCommodityDetailsLong();
                    that.endCountDownMode();
                    clearInterval(that.startTimer);
                } else {
                    that.startTimer = setInterval(function() {
                        that.startCountDown -= 1000;
                        if (that.startCountDown <= 0) {
                            that.getCommodityDetails();
                            if (that.startCountDown <= 0) {
                                that.getCommodityDetailsLong();
                                that.endCountDownMode();
                                that.$forceUpdate();
                                clearInterval(that.startTimer);
                            }
                        }
                    }, 1000);
                }
            },
            //商品详情长链接
            getCommodityDetailsLong: function() {
                let that = this;
                this.request.get(this.$store.state.httpUrl + "mobileInterf/longConnection", {
                    params: {
                        id: that.commodityId,
                        userId: that.$store.state.userId
                    }
                }).then(res => {
                    if (res.status == 200) {
                        that.commodityDetailsLong = res.data;
                        that.endCountDown = that.commodityDetailsLong.time;
                        if (that.timer) {
                            that.getCommodityDetails();
                        }
                    }
                });
            },
            getRecordList() {
                this.request.get(this.$store.state.httpUrl + "mobileInterf/recordList", {
                    params: {
                        id: this.commodityId,
                        userId: ''
                    }
                }).then(res => {
                    if (res.status == 200) {
                        this.recordList = res.data;
                    }
                });
            },
            handleClick(tab, event) {
                console.log(tab, event);
            },
            clickSwitchTab(type) {
                this.currentComp = type
            },
        },
        beforeDestroy() {
            clearInterval(this.startTimer);
            clearInterval(this.endTimer);
            this.startTimer = null;
            this.endTimer = null;
        }
    };
</script>
<style lang="less" scoped>
    .shopDetails {
        background: #FFFFFF;
        padding-bottom: 50px;
    }

    .shopDetails>div {
        width: 1200px;
        margin: 0 auto;
    }

    .goods-info {
        min-height: 430px;
        background: #fff;
        display: flex;

        .media {
            width: 280px;
            height: 320px;
            padding: 30px 50px 30px 0px;
        }

        .spec {
            width: calc(100% - 320px);
            padding: 30px 65px 30px 0;
            text-align: left;
            box-sizing: border-box;
        }
    }

    /deep/ .el-tabs__header {
        margin: 0;
    }

    /deep/ .el-tab-pane {
        background: #ffffff;
    }

    /deep/ .el-tabs__content {
        background: #ffffff;
        padding-top: 15px;
    }

    .xtx-button {
        appearance: none;
        border: none;
        outline: none;
        background: #fff;
        text-align: center;
        border: 1px solid transparent;
        border-radius: 4px;
        cursor: pointer;
        background: #D70606;
        color: #fff;
        border-radius: 10px;
        width: 180px;
        height: 50px;
        font-size: 16px;
        margin-top: 24px;
        margin-bottom: 24px;
    }

    .xtx-button2 {
        background: #CCCCCC;
        color: #999999;
    }

    .shoucan {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #999999;
        line-height: 28px;
    }

    .i-colea {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #999999;
        line-height: 28px;
    }

    .gongsi {
        font-size: 14px;
        color: #333333;
        line-height: 28px;
    }

    .borearss {
        width: 48px;
        height: 48px;
        border-radius: 50%;
        margin: 0 auto;
        margin-top: 10px;
        margin-bottom: 30px;
    }

    .borearss>img {
        width: 48px;
        height: 48px;
        background: #D70606;
        border-radius: 50%;
    }

    .moiuysa {
        background: #FFFFFF;
        border: 1px solid #D70606;
        border-radius: 8px;
        text-align: center;
        margin-top: 25px;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #D70606;
        line-height: 28px;
    }

    .xian {
        border-bottom: 1px solid #CCCCCC;
        margin-top: 20px;
        margin-bottom: 20px;
    }

    .moaksa {
        display: flex;
    }

    .siaosaf {
        font-size: 14px;
        color: #999999;
        line-height: 28px;
    }

    .anniu {
        background: #FEB960;
        border: none;
    }

    .siaosaf-q {
        margin-left: 22px;
        background: #FEB960;
        border-radius: 4px;
        font-size: 14px;
        color: #FFFFFF;
    }

    .mokisa {
        margin-left: 10px;
        font-size: 14px;
    }

    .bang-rigth {
        width: 260px;
        background: #FFFFFF;
        border: 1px solid #ABC0EC;
        border-radius: 10px;
        margin: 0 auto;
        padding: 20px;
        text-align: left;
    }

    .i-coleasss {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        line-height: 28px;
    }

    .container {
        display: flex;
        flex-wrap: wrap;
        text-align: center;
        border-bottom: 1px solid #CCCCCC;
        padding-bottom: 10px;
    }

    .container>.item {
        width: 33.33%;
    }

    .displa {
        display: flex;
        flex-direction: column;
        align-items: left;
    }

    .evaluation-box {
        padding-top: 20px;

        div {
            display: flex;
            font-size: 14px;
            text-align: left;
            color: #333333;
            margin-bottom: 8px;
            line-height: 24px;
        }
    }

    .evaluation-box>div>div:nth-child(1) {
        width: 100px;
        color: #999999;
    }

    .productDetail {
        .detailTabs {
            height: 46px;
            line-height: 46px;

            border-bottom: 2px solid #D70606;
            display: flex;

            span {
                padding: 0 30px;
                cursor: pointer;
                color: #333333;
                font-size: 16px;
            }

            .compActive {
                background: #D70606;
                color: #ffffff;
            }
        }
    }

    .goods-sku {
        .clap {
            font-size: 20px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #333333;
            text-align: left;
        }

        .g-resa {

            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #666666;
        }

        .iponer {
            position: relative;
            background: #F2F6FF;
            color: #ffffff;
            position: relative;
            padding: 20px;

            .posasa {
                position: absolute;
                right: 32px;
                top: 22px;

                .riesa {
                    font-size: 14px;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: #333333;
                    line-height: 28px;
                }
            }

            .g-price {
                .g-rena {
                    display: inline-block;
                    width: 80px;
                    text-align: right;
                    font-size: 14px;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: #666666;
                }
            }
        }

        .rechargeItem {

            /* width: 290px; */
            overflow: hidden;
            border-radius: 20px;
            margin-bottom: 20px;
            margin-top: 18px;
        }

        .iperssaa {
            background: #DDECFA;
            cursor: pointer;
            padding: 0 20px;
            height: 40px;
            line-height: 40px;
            text-align: left;
            font-size: 14px;
            color: #666666;

            .miaosha {
                font-size: 18px;
                font-weight: bold;
                color: #3166D6;
                margin-left: 20px;
            }

            .iperssaa_over {
                display: block;
                text-align: center;
            }
        }
    }

    /deep/.el-tabs--top {
        margin: 0 auto;
    }

    /deep/.mokis {
        margin: 0 auto;
    }

    /deep/ .el-tabs__nav {
        width: 1200px;
        margin: 0 auto;
    }

    /deep/ .el-tabs__active-bar {
        background-color: transparent !important;
    }

    /deep/ .el-table__body tr.current-row>td {
        background-color: #add8e6 !important;
    }

    /*去掉tabs底部的下划线*/
    /deep/ .el-tabs__nav-wrap::after {
        position: static !important;
    }

    /deep/.el-tabs__nav-scroll {
        background-color: #D70606;
    }

    /deep/.el-tabs__item.is-active {
        color: #FFFFFF;
    }

    /deep/ .el-tabs__item {
        color: #81AAFF;
    }

    .rechargeItemTop {
        background: #F2F6FF;
        color: #ffffff;
        position: relative;
        padding: 20px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        border: 1px solid #CCDDFF;
    }

    .shopDetails>.pup {
        position: fixed;
        width: 460px;
        height: 360px;
        background: #FFFFFF;
        box-shadow: 0px 1px 7px 0px rgba(58, 138, 250, 0.35);
        box-sizing: border-box;
        border-radius: 15px;
        top: calc(50% - 180px);
        left: calc(50% - 230px);
    }

    .mark {
        position: fixed;
        left: 0;
        top: 0;
        width: 100% !important;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
    }

    .mark2 {
        z-index: 3;
    }

    .pup>div {
        padding: 0 20px;
        margin-top: 18px;
        display: flex;
    }

    .pup div,
    .pup span {
        font-size: 14px;
    }

    .pup>div>div:nth-child(1) {
        min-width: 100px;
        max-width: 120px;
        text-align: right;
        color: #999999;
    }

    .pup>div>div:nth-child(2) {
        color: #333333;
        margin-left: 20px;
    }

    .pup>div:nth-child(1) {
        display: block;
        text-align: right;
        height: 36px;
        line-height: 36px;
        color: #FFFFFF;
        background: #6698FE;
        border-radius: 15px 15px 0 0;
        margin-top: 0;
    }

    .pup>div:nth-child(2) {
        font-size: 18px;
        font-weight: bold;
        color: #333333;
    }

    .pup>div:nth-child(3) {}

    .pup>div:nth-child(4) {
        border-bottom: 1px solid #CCCCCC;
    }

    .pup>div:nth-child(4)>div:nth-child(2) {
        display: flex;
        width: 50%;
        padding-bottom: 18px;
    }

    .pup>div:nth-child(4)>div:nth-child(2)>div:nth-child(1) {
        margin-right: 20px;
    }

    .pup>div:nth-child(4)>div>div:nth-child(2) {
        color: #999999;
        margin-right: 20px;
    }

    .pup>div:nth-child(3)>div:nth-child(1),
    .pup>div:nth-child(5)>div:nth-child(1) {
        padding-top: 8px;
    }

    .pup>div:nth-child(3)>div:nth-child(2),
    .pup>div:nth-child(5)>div:nth-child(2) {
        display: flex;
    }

    .pup>div:nth-child(3)>div:nth-child(2)>div:nth-child(1),
    .pup>div:nth-child(5)>div:nth-child(2)>div:nth-child(1),
    .pup>div:nth-child(3)>div:nth-child(2)>div:nth-child(3),
    .pup>div:nth-child(5)>div:nth-child(2)>div:nth-child(3) {
        width: 30px;
        height: 30px;
        line-height: 24px;
        background: #FFFFFF;
        border: 1px solid #CCCCCC;
        box-sizing: border-box;
        cursor: pointer;
    }

    .pup>div:nth-child(3)>div:nth-child(2)>div:nth-child(2),
    .pup>div:nth-child(5)>div:nth-child(2)>div:nth-child(2) {
        width: 100px;
        height: 30px;
        border: 1px solid #CCCCCC;
        box-sizing: border-box;
        border-left: none;
        border-right: none;
    }

    .pup>div:nth-child(3)>div:nth-child(2)>div:nth-child(2)>input,
    .pup>div:nth-child(5)>div:nth-child(2)>div:nth-child(2)>input {
        width: 100%;
        border: none;
        height: 26px;
        text-align: center !important;
        padding: 0;
    }

    .pup>div:nth-child(8) {
        width: 230px;
        height: 40px;
        line-height: 40px;
        background: #6698FE;
        border-radius: 5px;
        color: #FFFFFF;
        cursor: pointer;
        margin: 0 auto;
        margin-top: 18px;
        display: block;
        text-align: center;
    }

    .mokis {
        background: #FFE8D6;
        padding: 17px 30px;
        display: flex;
        justify-content: space-between;
    }

    .mokis2 {
        background: #EAF8F0;
    }

    .mokisas {
        padding: 16px 30px;
        display: flex;
        justify-content: space-between;
        border: 1px solid #EBEEF5;
    }

    .mokiiua span,
    .mokisas span {
        font-size: 14px;
        cursor: pointer;
    }

    .mokiiua {
        display: flex;
        padding: 16px 0px;
    }

    .dassaf {
        border: 1px solid #EBEEF5;
        padding: 0 30px;
        border-top: none;
    }

    .dassaf>div:nth-child(2) {}

    .shopDetails>.pup2 {
        position: fixed;
        width: 400px;
        background: #FFFFFF;
        box-shadow: 0px 1px 7px 0px rgba(58, 138, 250, 0.35);
        box-sizing: border-box;
        border-radius: 15px;
        top: calc(50% - 100px);
        left: calc(50% - 200px);
        z-index: 4;
    }

    .pup2>div {
        padding: 0 20px;
        margin-top: 18px;
        display: flex;
    }

    .pup2 div,
    .pup2 span {
        font-size: 14px;
    }

    .pup2>div:nth-child(2) {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
    }

    .pup2>div:nth-child(2)>div {
        width: 50%;
        display: flex;
        margin-bottom: 20px;
        text-align: left;
    }

    .pup2>div>div>div:nth-child(1) {
        min-width: 100px;
        max-width: 120px;
        color: #999999;
    }

    .pup2>div>div>div:nth-child(2) {
        color: #333333;
        padding-right: 40px;
    }

    .pup2>div:nth-child(1) {
        display: block;
        text-align: right;
        height: 36px;
        line-height: 36px;
        color: #FFFFFF;
        background: #6698FE;
        border-radius: 15px 15px 0 0;
        margin-top: 0;
    }

    .pup2>div:last-child {
        display: flex;
        justify-content: space-around;
        padding-bottom: 30px;
        margin-top: 10px;
    }

    .pup2>div:last-child>div {
        width: 140px;
        height: 40px;
        border-radius: 5px;
        box-sizing: border-box;
        line-height: 40px;
        cursor: pointer;
    }

    .pup2>div:last-child>div:nth-child(1) {
        color: #FFFFFF;
        background: #6698FE;
    }

    .pup2>div:last-child>div:nth-child(2) {
        background: rgba(102, 152, 254, 0.22);
        border: 1px solid #D70606;
        border-radius: 5px;
        color: #6698FE;
    }
</style>



// WEBPACK FOOTER //
// src/view/shop/shopJpDetailsBuy.vue